<template>
  <div>
    <SubMenu title="Currently Online" />
    <section>
      <div class="tw-mx-2">
        <div class="tw-text-xs">
          <Debug
            label="usersOnline"
            :data="usersOnline"
          />
          <Debug
            label="usersOnlineUnique"
            :data="usersOnlineUnique"
            :expanded="true"
          />
          <Debug
            label="usersOnlineByPlatform"
            :data="usersOnlineByPlatform"
          />
          <Debug
            label="usersOnlineUniqueByPlatform"
            :data="usersOnlineUniqueByPlatform"
            :expanded="true"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  computed: {
    ...sync([
      'navigation/usersOnline', //
      'navigation/usersOnlineUnique', //
      'navigation/usersOnlineByPlatform', //
      'navigation/usersOnlineUniqueByPlatform', //
    ]),
  },
};
</script>
